export default "__VITE_ASSET__BttatCMC__"